<div class="mx-4">
  <h1 class="app">Profile</h1>


  <!-- <div class="mt-[60px]">
    <div class="mt-2">
      <h3 class="app">Profile Picture</h3>
    </div>
  </div> -->
  
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">
    <div class="flex w-full gap-[60px]">
      <div class="w-1/2">
        <lib-form-text
        label="First Name"
        formControlName="firstName">
      </lib-form-text>
    </div>
    
    <div class="w-1/2">
      <lib-form-text
      label="Last Name"
      formControlName="lastName">
    </lib-form-text>
  </div>
</div>


<div class="flex w-full gap-[60px]">
  <div class="w-1/2">
    <lib-form-text
    label="Email"
    formControlName="email"
    [readonly]="true"
    >
  </lib-form-text>
</div>
<div class="w-1/2 flex items-end mb-[18px]">
  <lib-button
  class="underline"
  [cssType]="'btn-link'"
  [bold]="true"
  text="Change Password"
  [type]="'button'"
         (click)="changePassword()"
         >
        </lib-button>
      </div>
    </div>
    @if (!authStore.isAdmin()) {
      <div class="flex w-full gap-[60px]">
        <div class="w-1/2">
          <lib-form-phone
          label="Phone #"
          formControlName="phone">
        </lib-form-phone>
        </div>
        <div class="w-1/2"></div>
      </div>
    }
    <div class="flex w-full gap-[60px]">
      <div class="w-1/2">
        <lib-button
        [cssType]="'btn-primary'"
        text="Update Profile"
        [type]="'submit'"
        [disabled]="!profileForm.valid"
        >
      </lib-button>
    </div>
      <div class="w-1/2"></div>
    </div>
  </form>
</div>